import { render, staticRenderFns } from "./characterAuth.vue?vue&type=template&id=863670bc&scoped=true&"
import script from "./characterAuth.vue?vue&type=script&lang=js&"
export * from "./characterAuth.vue?vue&type=script&lang=js&"
import style0 from "./characterAuth.vue?vue&type=style&index=0&id=863670bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863670bc",
  null
  
)

export default component.exports